import { render, staticRenderFns } from "./CompetitionsList.vue?vue&type=template&id=47eaef20&scoped=true&"
import script from "./CompetitionsList.vue?vue&type=script&lang=js&"
export * from "./CompetitionsList.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionsList.vue?vue&type=style&index=0&id=47eaef20&lang=scss&scoped=true&"
import style1 from "./CompetitionsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eaef20",
  null
  
)

export default component.exports